import {FC} from 'react'
import {downloadTemplatePoint, uploadMasivePoint} from '../../../../services'
import {ERROR_MESSAGE_SYSTEM} from '../../../../../../util/Constants'
import {ShowSnackBar} from '../../../../../../util/functions'
import {FormMasive} from '../../../../../../components/UI/Form/MasiveV2'
const MasiveUploadPoint: FC = () => {
  const handleUpload = async (formData: FormData) => {
    try {
      const data = await uploadMasivePoint(formData) // Use the service to upload the file
      return data
    } catch (error) {
      ShowSnackBar(ERROR_MESSAGE_SYSTEM, 'error')
    }
  }
  return (
    <FormMasive
      serviceTemplate={downloadTemplatePoint}
      handleSendService={handleUpload}
      textData1='Carga masiva de Puntos:'
      textData='Carga masiva de Puntos:'
      title='Puntos'
    />
  )
}

export {MasiveUploadPoint}
